import type { Community } from '@communities/community/domain/Community';
import { CommunityAuditHeaderSection, AuditAnalyticsSection } from '@internal-audit/components/CommunityAuditHeaderSection';
import type { FlexibleAuditSession } from '@internal-audit/domain/graphql-types';
import { useAuditAnalyticsData } from '@internal-audit/hooks/useAuditAnalyticsData';

interface SessionsPageHeaderProps {
  community: Community | null;
  sessions: FlexibleAuditSession[];
  sessionsLoading: boolean;
}

/**
 * Header section component with hero background
 * Contains the community audit header
 */
export function SessionsPageHeader({ community, sessions, sessionsLoading }: SessionsPageHeaderProps) {
  return (
    <div>
      <CommunityAuditHeaderSection auditSessions={sessions} community={community} isLoading={sessionsLoading} />
    </div>
  );
}

/**
 * Analytics section for page body
 * Separated from header to enable the new design system header
 */
export function SessionsPageAnalytics({ community, sessions, sessionsLoading }: SessionsPageHeaderProps) {
  // Fetch analytics data using the shared hook
  const {
    auditReports,
    comprehensiveAnalytics,
    isLoading: analyticsLoading,
  } = useAuditAnalyticsData({
    communityId: community?.id,
  });

  const isLoading = sessionsLoading || analyticsLoading;

  return <AuditAnalyticsSection auditReports={auditReports} auditSessions={sessions} comprehensiveAnalytics={comprehensiveAnalytics} isLoading={isLoading} />;
}
